import { render, staticRenderFns } from "./knowledge-detail.vue?vue&type=template&id=884ee7e2&scoped=true"
import script from "./knowledge-detail.vue?vue&type=script&lang=js"
export * from "./knowledge-detail.vue?vue&type=script&lang=js"
import style0 from "./knowledge-detail.vue?vue&type=style&index=0&id=884ee7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884ee7e2",
  null
  
)

export default component.exports